import { render, staticRenderFns } from "./EditMultipositionSlot.vue?vue&type=template&id=27ffd768&scoped=true"
import script from "./EditMultipositionSlot.vue?vue&type=script&lang=ts"
export * from "./EditMultipositionSlot.vue?vue&type=script&lang=ts"
import style0 from "./EditMultipositionSlot.vue?vue&type=style&index=0&id=27ffd768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ffd768",
  null
  
)

export default component.exports